(function () {

  function moveKiwiButton() {
    // Botón real de Kiwi
    const kiwiBtn = document.querySelector(
      'button.ks-calculator-modal-button, button.sizing-calculator-modal-button'
    );

    if (!kiwiBtn) {
      return false;
    }

    // Buscar el fieldset de "Talla"
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    let sizeFieldset = null;

    fieldsets.forEach(fs => {
      const legend = fs.querySelector('legend');
      const text = (legend?.textContent || '').toLowerCase();

      if (text.includes('talla') || text.includes('size')) {
        sizeFieldset = fs;
      }
    });

    if (!sizeFieldset) {
      return false;
    }

    const values = sizeFieldset.querySelector('.variant-picker__option-values');
    if (!values) {
      return false;
    }

    // Mover el botón justo al lado de las tallas
    if (!values.contains(kiwiBtn)) {
      values.appendChild(kiwiBtn);
    }

    return true;
  }

  function run() {
    moveKiwiButton();
    setTimeout(moveKiwiButton, 300);
    setTimeout(moveKiwiButton, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
